"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePopover = void 0;
var react_1 = require("react");
var util_1 = require("./util");
var useElementRef_1 = require("./useElementRef");
var usePopover = function (_a) {
    var childRef = _a.childRef, positions = _a.positions, containerClassName = _a.containerClassName, containerParent = _a.containerParent, contentLocation = _a.contentLocation, align = _a.align, padding = _a.padding, reposition = _a.reposition, boundaryInset = _a.boundaryInset, onPositionPopover = _a.onPositionPopover;
    var popoverRef = useElementRef_1.useElementRef(containerClassName, {
        position: 'fixed',
        overflow: 'visible',
        top: '0px',
        left: '0px',
    });
    var positionPopover = react_1.useCallback(function (positionIndex, childRect, popoverRect, parentRect) {
        if (positionIndex === void 0) { positionIndex = 0; }
        if (childRect === void 0) { childRect = childRef.current.getBoundingClientRect(); }
        if (popoverRect === void 0) { popoverRect = popoverRef.current.getBoundingClientRect(); }
        if (parentRect === void 0) { parentRect = containerParent.getBoundingClientRect(); }
        if (contentLocation) {
            var _a = typeof contentLocation === 'function'
                ? contentLocation({
                    childRect: childRect,
                    popoverRect: popoverRect,
                    parentRect: parentRect,
                    position: 'custom',
                    align: 'custom',
                    padding: padding,
                    nudgedTop: 0,
                    nudgedLeft: 0,
                    boundaryInset: boundaryInset,
                })
                : contentLocation, inputTop = _a.top, inputLeft = _a.left;
            var left_1 = parentRect.left + inputLeft;
            var top_1 = parentRect.top + inputTop;
            popoverRef.current.style.transform = "translate(" + left_1 + "px, " + top_1 + "px)";
            onPositionPopover({
                childRect: childRect,
                popoverRect: popoverRect,
                parentRect: parentRect,
                position: 'custom',
                align: 'custom',
                padding: padding,
                nudgedTop: 0,
                nudgedLeft: 0,
                boundaryInset: boundaryInset,
            });
            return;
        }
        var isExhausted = positionIndex === positions.length;
        var position = isExhausted ? positions[0] : positions[positionIndex];
        var _b = util_1.getNewPopoverRect({
            childRect: childRect,
            popoverRect: popoverRect,
            parentRect: parentRect,
            position: position,
            align: align,
            padding: padding,
            reposition: reposition,
        }, boundaryInset), rect = _b.rect, boundaryViolation = _b.boundaryViolation;
        if (boundaryViolation && reposition && !isExhausted) {
            positionPopover(positionIndex + 1, childRect, popoverRect, parentRect);
            return;
        }
        var top = rect.top, left = rect.left, width = rect.width, height = rect.height;
        var shouldNudge = reposition && !isExhausted;
        var _c = util_1.getNudgedPopoverRect(rect, parentRect, boundaryInset), nudgedLeft = _c.left, nudgedTop = _c.top;
        var finalTop = top;
        var finalLeft = left;
        if (shouldNudge) {
            finalTop = nudgedTop;
            finalLeft = nudgedLeft;
        }
        popoverRef.current.style.transform = "translate(" + finalLeft + "px, " + finalTop + "px)";
        onPositionPopover({
            childRect: childRect,
            popoverRect: {
                top: finalTop,
                left: finalLeft,
                width: width,
                height: height,
                right: finalLeft + width,
                bottom: finalTop + height,
            },
            parentRect: parentRect,
            position: position,
            align: align,
            padding: padding,
            nudgedTop: nudgedTop - top,
            nudgedLeft: nudgedLeft - left,
            boundaryInset: boundaryInset,
        });
    }, [
        childRef,
        popoverRef,
        positions,
        align,
        padding,
        reposition,
        boundaryInset,
        containerParent,
        contentLocation,
        onPositionPopover,
    ]);
    return [positionPopover, popoverRef];
};
exports.usePopover = usePopover;
//# sourceMappingURL=data:application/json;base64,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